import React, { useState } from 'react'
import { connect } from 'react-redux'
import { IonGrid, IonRow, IonCol, IonIcon, IonItem, IonText, IonCardSubtitle, IonInput, IonList, IonButton } from '@ionic/react';
import {  eye, eyeOff } from 'ionicons/icons';

import { SessionDefaultStateI } from '../../store/session/SessionReducer';

import ApiRequestor from '../../api_access/ApiRequestor';

import './UserProfile.css'
import Modal from '../Modal/Modal';

interface Props extends StateTypes { }

const ChangePassword: React.FC<Props> = (props): JSX.Element => {
    const [showCurrPass, setShowCurrPass] = useState(false)
    const [showNewPass, setShowNewPass] = useState(false)
    const [showNewPassRep, setShowNewPassRep] = useState(false)
    const [showModal, setShowModal] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const [textModalConfirm, setTextModalConfirm] = useState('')
    const [renderVar, setRenderVar] = useState<any>(true)
    const [textModal, setTextModal] = useState('')
    const [dataForm, saveDataForm] = useState({
        passwordOld: '',
        passwordNew: '',
        passwordRep: ''
    })
    const [errors, setErrors] = useState({
        passwordOld: '',
        passwordNew: '',
        passwordRep: ''
    })
    const { passwordOld, passwordNew, passwordRep } = dataForm;
    const regularExpressionPass = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

    const getDataForm = (e: any) => {
        saveDataForm({
            ...dataForm,
            [e.target.name]: e.detail.value!
        })
    }


    const validationForm = () => {
        const isEmpty = (value: any) => !value.trim();

        const errors = {
            passwordOld: isEmpty(dataForm.passwordOld)
                ? 'El campo no puede estar vacío.'
                : '',
            passwordNew: isEmpty(dataForm.passwordNew)
                ? 'El campo no puede estar vacío.'
                : !regularExpressionPass.test(dataForm.passwordNew) || dataForm.passwordNew.length >= 24
                    ? 'Entre 8 y 24 caracteres, al menos 1 mayúscula, 1 minúsculas, 1 número y 1 carácter especial (#?!@$%^&*-)'
                    : '',
            passwordRep: dataForm.passwordNew !== dataForm.passwordRep
                ? 'Las constraseñas no coinciden'
                : ''
        }

        setErrors(errors as any);
        const hasErrors = Object.values(errors).some(error => error !== '');

        return hasErrors;
    }

    const changePass = async () => {
        validationForm();

        const accessToken = props.session.loginData.getAccessToken().getJwtToken()

        let valid = validationForm();

        if (!valid) {
            let data: any = {
                body: {
                    currPass: dataForm.passwordOld,
                    newPass: dataForm.passwordNew,
                    accessToken: accessToken
                }
            }

            const response: any = await ApiRequestor.requestToApi('/auth/change-pass', "POST", data, "USER")

            if (response && response.status === 200) {
                setTextModal('Contraseña cambiada Correctamente')
                console.log(textModal)
                setShowModalConfirm(true)
                clearFields()
            } else {
                if (response && response.includes("status code 500")) {
                    setTextModalConfirm("No se pudo realizar el cambio de contraseña, intente nuevamente en otro momento.")
                    setShowModalConfirm(true)
                    clearFields()
                }
            }
        } else {
            validationForm()
        }
    }

    const onSubmit = () => {
        if (!validationForm()) {
            console.log(validationForm())
            setShowModal(true)
        } else {
            setShowModal(false)
        }
    }

    const clearFields = () => {
        saveDataForm({
            passwordOld: '',
            passwordNew: '',
            passwordRep: ''
        })
    }

    const handlePasswordVisibility = (id: string) => {
        switch (id) {
            case "currPass":
                setShowCurrPass(showCurrPass ? false : true)
                break;
            case "newPass":
                setShowNewPass(showNewPass ? false : true)
                break;
            case "newPassRep":
                setShowNewPassRep(showNewPassRep ? false : true)
                break;
        }
    }

    const returnChildrenModal = (): JSX.Element => {
        return (
            <>
                <IonText><h6 className="ion-padding ion-text-center ion-margin-horizontal profile-modal-text"> ¿Está seguro que desea modificar su contraseña?</h6></IonText>
                <IonRow className="ion-text-center ion-padding-bottom">
                    <IonCol size-xl="6" size-lg="6" size-md="6">
                        <IonButton className="profile-button" fill="outline" size="small" onClick={() => { changePass(); setShowModal(false) }}>Aceptar</IonButton>
                    </IonCol>
                    <IonCol size-xl="6" size-lg="6" size-md="6">
                        <IonButton className="profile-button" fill="outline" size="small" onClick={() => setShowModal(false)}>Cancelar</IonButton>
                    </IonCol>
                </IonRow>
            </>
        )
    }

    const returnCHildrenModalConfirm = (): JSX.Element => {
        return (
            <>
                <IonText><p className="ion-padding ion-text-center profile-modal-text"> {textModalConfirm}</p></IonText>
                <IonRow className="ion-text-center ion-padding-bottom">
                    <IonCol size-lg="12" size-md="12">
                        <IonButton className="profile-button" fill="outline" size="small" onClick={() => { setShowModalConfirm(false) }}>Aceptar</IonButton>
                    </IonCol>
                </IonRow>
            </>
        )
    }

    return (
        <IonGrid>
            <IonCardSubtitle className="profile-subtitle">Cambio de contraseña</IonCardSubtitle>
            <IonRow>
                <IonCol>
                    {renderVar &&
                        <IonList>
                            <IonRow>
                                <IonCol size-xl="6" size-lg="6" size-md="6" size-sm="12" size-xs="12">
                                    <IonCardSubtitle className="perfil-labels">Constraseña actual</IonCardSubtitle>
                                    <IonItem lines="none" className="profile-item">
                                        <IonInput
                                            type={showCurrPass ? 'text' : 'password'}
                                            placeholder="Contraseña actual"
                                            name="passwordOld"
                                            className="profile-input ion-no-padding"
                                            value={passwordOld}
                                            onIonChange={(e) => {
                                                getDataForm(e)
                                            }} />
                                        <IonIcon icon={showCurrPass ? eye : eyeOff} onClick={(id) => handlePasswordVisibility("currPass")} className="profile-icon-eye" />
                                    </IonItem>
                                    <IonText>
                                        <p className={errors.passwordOld ? "login-valid-text" : "ion-hide"}>{errors.passwordOld}</p>
                                    </IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size-xl="6" size-lg="6" size-md="6" size-sm="12" size-xs="12">
                                    <IonCardSubtitle className="perfil-labels">Nueva contraseña</IonCardSubtitle>
                                    <IonItem lines="none" className="profile-item">
                                        <IonInput
                                            type={showNewPass ? 'text' : 'password'}
                                            placeholder="Mínimo 8 caracteres"
                                            name="passwordNew"
                                            className="profile-input ion-no-padding"
                                            value={passwordNew}
                                            onIonChange={(e) => {
                                                getDataForm(e)
                                            }} />
                                        <IonIcon icon={showNewPass ? eye : eyeOff} onClick={(id) => handlePasswordVisibility("newPass")} className="profile-icon-eye" />
                                    </IonItem>
                                    <IonText>
                                        <p className={errors.passwordNew ? "login-valid-text" : "ion-hide"}>{errors.passwordNew}</p>
                                    </IonText>
                                </IonCol>
                                <IonCol size-xl="6" size-lg="6" size-md="6" size-sm="12" size-xs="12">
                                    <IonCardSubtitle className="perfil-labels">Repetir nueva contraseña</IonCardSubtitle>
                                    <IonItem lines="none" className="profile-item">
                                        <IonInput
                                            type={showNewPassRep ? 'text' : 'password'}
                                            placeholder="Mínimo 8 caracteres"
                                            name="passwordRep"
                                            className="profile-input ion-no-padding"
                                            value={passwordRep}
                                            onIonChange={(e) => {
                                                getDataForm(e)
                                            }} />
                                        <IonIcon icon={showNewPassRep ? eye : eyeOff} onClick={(id) => handlePasswordVisibility("newPassRep")} className="profile-icon-eye" />
                                    </IonItem>
                                    <IonText>
                                        <p className={errors.passwordRep ? "login-valid-text" : "ion-hide"}>{errors.passwordRep}</p>
                                    </IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow className="ion-margin-top profile-row-button">
                                <IonButton className="profile-button" fill="outline" onClick={onSubmit}>Modificar contraseña</IonButton>
                            </IonRow>
                        </IonList>
                    }
                </IonCol>
            </IonRow>


            <Modal
                modalChildren={
                    {
                        id: "",
                        styles: "profile-modal",
                        isOpen: showModal,
                        onDidDismiss: () => setShowModal(false),
                        children: returnChildrenModal()
                    }
                }
            />

            <Modal
                modalChildren={
                    {
                        id: "",
                        styles: "profile-modal",
                        isOpen: showModalConfirm,
                        onDidDismiss: () => setShowModalConfirm(false),
                        children: returnCHildrenModalConfirm()
                    }
                }
            />

        </IonGrid>
    )
}

//Redux state and actions dispatchers
interface StateTypes {
    session: SessionDefaultStateI,
}

const mapStateToProps = (state: StateTypes) => {
    return {
        session: state.session,
    };
};

export default connect(mapStateToProps)(ChangePassword);